import { useRoute } from '@react-navigation/native'
import { getAuth, signInAnonymously } from 'firebase/auth'
import { FC, useEffect } from 'react'
import { customerStation } from '../../constants/stations'
import { TabsEnum } from '../../constants/tabs'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { setCurrentTab } from '../../redux/reducers/app'
import { selectLicense, setLicense } from '../../redux/reducers/license'
import { setCurrentStation, stationSelectors } from '../../redux/reducers/station'
import OrderColumns from '../OrderColumns/OrderColumns'
import MainLoader from '../UI/loaders/MainLoader'
import CustomerAppBar from './CustomerAppBar'

interface IRoutePath {
    licenseName: string
    firebaseToken: string
    language: string
}

const Customer: FC = () => {
    const license = useAppSelector(selectLicense)
    const currentStation = useAppSelector(stationSelectors.currentStation)

    const dispatch = useAppDispatch()

    const route = useRoute()

    const { licenseName, firebaseToken, language } = route.params as IRoutePath

    useEffect(() => {
        ;(async () => {
            const auth = getAuth()

            await signInAnonymously(auth)

            dispatch(
                setLicense({
                    token: firebaseToken,
                    url: '',
                    name: licenseName.replace(/%20/g, ' '),
                    language,
                })
            )
            dispatch(setCurrentTab(TabsEnum.TAKE_AWAY))
            dispatch(setCurrentStation(customerStation))
        })()
    }, [licenseName, firebaseToken, language, dispatch])

    if (!license || !currentStation) {
        return <MainLoader />
    }

    return (
        <>
            <CustomerAppBar />
            <OrderColumns />
        </>
    )
}

export default Customer
